import React from 'react';
import { Form, Avatar, Tooltip, Switch } from 'antd';
import useAuthUploadSrc from '../../../hooks/useAuthUploadSrc';
import SelectWithClearButton from './SelectWithClearButton';

const AvatarBadge = ({ url, name }) => {
  const src = useAuthUploadSrc(url);
  return (
    <Avatar
      size={20}
      src={src}
      style={{
        backgroundColor: '#e6f7ff',
        border: '1px solid #91d5ff',
        fontSize: 10,
        color: '#1890ff',
        verticalAlign: 'middle',
      }}
    >
      {name?.[0] || 'AI'}
    </Avatar>
  );
};

const AiStaffSelectField = ({
  fieldPath = ['validation', 'aiStaffId'],
  selectedNode,
  aiStaffs,
  aiStaffOptions,
  loadingAiStaffs,
  handleAiStaffChange,
  handleNodeDataChange,
  t,
}) => {
  const isValidation = fieldPath[0] === 'validation';
  const currentStaffId = isValidation
    ? selectedNode?.data?.validation?.aiStaffId
    : selectedNode?.data?.aiStaffId;
  const currentStaff = currentStaffId
    ? aiStaffs.find(s => s.id === currentStaffId)
    : null;

  // useAiStaffMemory 預設 true（未設定時視為開啟）
  const useMemory = isValidation
    ? (selectedNode?.data?.validation?.useAiStaffMemory ?? true)
    : (selectedNode?.data?.useAiStaffMemory ?? true);

  const handleMemoryToggle = (checked) => {
    if (!handleNodeDataChange) return;
    if (isValidation) {
      handleNodeDataChange({
        validation: {
          ...(selectedNode?.data?.validation || {}),
          useAiStaffMemory: checked,
        },
      });
    } else {
      handleNodeDataChange({ useAiStaffMemory: checked });
    }
  };

  return (
    <>
      <Form.Item
        label={
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            {t('workflowDesigner.aiStaffLabel')}
            {currentStaff && (
              <Tooltip title={`${currentStaff.displayName || ''}${currentStaff.jobTitle ? ' - ' + currentStaff.jobTitle : ''}`}>
                <span>
                  <AvatarBadge url={currentStaff.avatarUrl} name={currentStaff.displayName} />
                </span>
              </Tooltip>
            )}
          </span>
        }
        tooltip={t('workflowDesigner.aiStaffHelp')}
      >
        <SelectWithClearButton
          clearText={t('workflowDesigner.clear')}
          loading={loadingAiStaffs}
          placeholder={t('workflowDesigner.aiStaffPlaceholder')}
          options={aiStaffOptions}
          value={currentStaffId || undefined}
          showSearch
          optionFilterProp="label"
          onChange={(val) => handleAiStaffChange(val, fieldPath)}
        />
      </Form.Item>
      {currentStaffId && (
        <Form.Item
          label={t('workflowDesigner.aiStaffUseMemory')}
          tooltip={t('workflowDesigner.aiStaffUseMemoryHelp')}
        >
          <Switch
            checked={useMemory}
            onChange={handleMemoryToggle}
            checkedChildren="ON"
            unCheckedChildren="OFF"
            size="small"
          />
        </Form.Item>
      )}
    </>
  );
};

export default AiStaffSelectField;
